import { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useBetSlip } from '../../../components/feature/BetSlipContext';
import PageHero from '../../../components/feature/PageHero';

// ─── Types ────────────────────────────────────────────────────────────────────

interface TeamOption {
  name: string;
  spread: string;
  prob: string;
  price: string;
  payout: string;
  profit: string;
}

interface SpreadCard {
  sport: 'NFL' | 'NBA' | 'NHL';
  date: string;
  matchup: string;
  time: string;
  volume: string;
  teams: [TeamOption, TeamOption];
}

// ─── Market Data ──────────────────────────────────────────────────────────────

const ALL_CARDS: SpreadCard[] = [
  {
    sport: 'NFL', date: 'Jan 28, 2025',
    matchup: 'Buffalo Bills @ Kansas City Chiefs', time: '3:00 PM EST',
    volume: '$2.4M',
    teams: [
      { name: 'Buffalo Bills +3.5', spread: '+3.5', prob: '48%', price: '$1.00', payout: '$2.07', profit: '+$1.07' },
      { name: 'Kansas City Chief... -3.5', spread: '-3.5', prob: '52%', price: '$1.00', payout: '$1.91', profit: '+$0.91' },
    ],
  },
  {
    sport: 'NFL', date: 'Jan 28, 2025',
    matchup: 'Philadelphia Eagles @ San Francisco 49ers', time: '6:30 PM EST',
    volume: '$2.1M',
    teams: [
      { name: 'Philadelphia Eagl... +2.5', spread: '+2.5', prob: '50%', price: '$1.00', payout: '$1.99', profit: '+$0.99' },
      { name: 'San Francisco 49... -2.5', spread: '-2.5', prob: '50%', price: '$1.00', payout: '$1.99', profit: '+$0.99' },
    ],
  },
  {
    sport: 'NBA', date: 'Jan 26, 2025',
    matchup: 'Milwaukee Bucks @ Boston Celtics', time: '7:30 PM EST',
    volume: '$1.8M',
    teams: [
      { name: 'Milwaukee Bucks... +5.5', spread: '+5.5', prob: '45%', price: '$1.00', payout: '$2.21', profit: '+$1.21' },
      { name: 'Boston Celtics -5.5', spread: '-5.5', prob: '55%', price: '$1.00', payout: '$1.81', profit: '+$0.81' },
    ],
  },
  {
    sport: 'NBA', date: 'Jan 26, 2025',
    matchup: 'Denver Nuggets @ Los Angeles Lakers', time: '10:00 PM EST',
    volume: '$1.6M',
    teams: [
      { name: 'Denver Nuggets -... +1.5', spread: '+1.5', prob: '52%', price: '$1.00', payout: '$1.91', profit: '+$0.91' },
      { name: 'Los Angeles Lake... -1.5', spread: '-1.5', prob: '48%', price: '$1.00', payout: '$2.07', profit: '+$1.07' },
    ],
  },
  {
    sport: 'NHL', date: 'Jan 27, 2025',
    matchup: 'Boston Bruins @ Toronto Maple Leafs', time: '7:00 PM EST',
    volume: '$890K',
    teams: [
      { name: 'Boston Bruins +1.5', spread: '+1.5', prob: '55%', price: '$1.00', payout: '$1.81', profit: '+$0.81' },
      { name: 'Toronto Maple L... -1.5', spread: '-1.5', prob: '45%', price: '$1.00', payout: '$2.21', profit: '+$1.21' },
    ],
  },
  {
    sport: 'NHL', date: 'Jan 27, 2025',
    matchup: 'Colorado Avalanche @ Edmonton Oilers', time: '9:00 PM EST',
    volume: '$765K',
    teams: [
      { name: 'Colorado Avalanc... +1.5', spread: '+1.5', prob: '48%', price: '$1.00', payout: '$2.07', profit: '+$1.07' },
      { name: 'Edmonton Oilers ... -1.5', spread: '-1.5', prob: '52%', price: '$1.00', payout: '$1.91', profit: '+$0.91' },
    ],
  },
  {
    sport: 'NBA', date: 'Jan 27, 2025',
    matchup: 'Golden State Warriors @ Phoenix Suns', time: '10:30 PM EST',
    volume: '$1.4M',
    teams: [
      { name: 'Golden State Wa... +3.5', spread: '+3.5', prob: '47%', price: '$1.00', payout: '$2.12', profit: '+$1.12' },
      { name: 'Phoenix Suns -3.5', spread: '-3.5', prob: '53%', price: '$1.00', payout: '$1.88', profit: '+$0.88' },
    ],
  },
  {
    sport: 'NFL', date: 'Jan 28, 2025',
    matchup: 'Green Bay Packers @ Dallas Cowboys', time: '4:25 PM EST',
    volume: '$1.9M',
    teams: [
      { name: 'Green Bay Packer... +4.5', spread: '+4.5', prob: '46%', price: '$1.00', payout: '$2.16', profit: '+$1.16' },
      { name: 'Dallas Cowboys -... -4.5', spread: '-4.5', prob: '54%', price: '$1.00', payout: '$1.84', profit: '+$0.84' },
    ],
  },
  {
    sport: 'NBA', date: 'Jan 27, 2025',
    matchup: 'New York Knicks @ Miami Heat', time: '7:30 PM EST',
    volume: '$1.2M',
    teams: [
      { name: 'New York Knicks ... -2.5', spread: '-2.5', prob: '53%', price: '$1.00', payout: '$1.88', profit: '+$0.88' },
      { name: 'Miami Heat +2.5', spread: '+2.5', prob: '47%', price: '$1.00', payout: '$2.12', profit: '+$1.12' },
    ],
  },
  {
    sport: 'NHL', date: 'Jan 27, 2025',
    matchup: 'Florida Panthers @ Tampa Bay Lightning', time: '7:00 PM EST',
    volume: '$680K',
    teams: [
      { name: 'Florida Panthers ... +1.5', spread: '+1.5', prob: '49%', price: '$1.00', payout: '$2.03', profit: '+$1.03' },
      { name: 'Tampa Bay Light... -1.5', spread: '-1.5', prob: '51%', price: '$1.00', payout: '$1.95', profit: '+$0.95' },
    ],
  },
  {
    sport: 'NBA', date: 'Jan 27, 2025',
    matchup: 'Oklahoma City Thunder @ Dallas Mavericks', time: '8:30 PM EST',
    volume: '$1.5M',
    teams: [
      { name: 'Oklahoma City T... -1.5', spread: '-1.5', prob: '51%', price: '$1.00', payout: '$1.95', profit: '+$0.95' },
      { name: 'Dallas Mavericks ... +1.5', spread: '+1.5', prob: '49%', price: '$1.00', payout: '$2.03', profit: '+$1.03' },
    ],
  },
  {
    sport: 'NHL', date: 'Jan 27, 2025',
    matchup: 'Los Angeles Kings @ Vegas Golden Knights', time: '10:00 PM EST',
    volume: '$720K',
    teams: [
      { name: 'Los Angeles King... +1.5', spread: '+1.5', prob: '44%', price: '$1.00', payout: '$2.26', profit: '+$1.26' },
      { name: 'Vegas Golden Kni... -1.5', spread: '-1.5', prob: '56%', price: '$1.00', payout: '$1.78', profit: '+$0.78' },
    ],
  },
];

// ─── Sport Badge Colors ───────────────────────────────────────────────────────

const SPORT_BADGE: Record<string, { bg: string; text: string; dot: string }> = {
  NFL: { bg: 'bg-amber-500/20', text: 'text-amber-400', dot: 'bg-amber-400' },
  NBA: { bg: 'bg-orange-500/20', text: 'text-orange-400', dot: 'bg-orange-400' },
  NHL: { bg: 'bg-cyan-500/20', text: 'text-cyan-400', dot: 'bg-cyan-400' },
};

// ─── Spread Card Component ────────────────────────────────────────────────────

function SpreadCardItem({ card }: { card: SpreadCard }) {
  const [selected, setSelected] = useState<0 | 1>(1);
  const [added, setAdded] = useState(false);
  const { addBet } = useBetSlip();
  const badge = SPORT_BADGE[card.sport];

  const selectedTeam = card.teams[selected];

  const handleAddToSlip = () => {
    const baseSpreadNum = parseFloat(selectedTeam.spread);
    const baseProbNum = parseFloat(selectedTeam.prob) / 100;
    addBet({
      id: `spread-${card.matchup}-${selectedTeam.name}`.replace(/\s+/g, '-').toLowerCase(),
      market: `${card.sport} Spread`,
      matchup: card.matchup,
      pick: selectedTeam.name,
      price: selectedTeam.price,
      payout: selectedTeam.payout,
      profit: selectedTeam.profit,
      badge: card.sport,
      badgeColor: `${badge.bg} ${badge.text} border-transparent`,
      isSpread: true,
      baseSpread: baseSpreadNum,
      baseProb: baseProbNum,
    });
    setAdded(true);
    setTimeout(() => setAdded(false), 1800);
  };

  return (
    <div className="rounded-xl border border-slate-700/80 overflow-hidden flex flex-col" style={{ background: '#1e2330' }}>
      {/* Header */}
      <div className="flex items-start justify-between px-4 pt-4 pb-2">
        <span className={`flex items-center gap-1.5 px-2.5 py-0.5 rounded-full text-xs font-bold ${badge.bg} ${badge.text}`}>
          <span className={`w-1.5 h-1.5 rounded-full ${badge.dot}`}></span>
          {card.sport}
        </span>
        <span className="text-xs text-slate-500">{card.date}</span>
      </div>

      {/* Matchup */}
      <div className="px-4 pb-2">
        <h3 className="text-sm font-bold text-white leading-snug">{card.matchup}</h3>
        <p className="text-xs text-slate-400 mt-0.5">{card.time}</p>
      </div>

      {/* Volume */}
      <div className="px-4 pb-3">
        <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-md text-xs font-semibold bg-teal-500/10 text-teal-400 border border-teal-500/20">
          <i className="ri-line-chart-line text-xs"></i>
          Vol: {card.volume}
        </span>
      </div>

      {/* Team Rows */}
      <div className="px-3 pb-3 space-y-1.5 flex-1">
        {card.teams.map((team, idx) => (
          <div
            key={idx}
            onClick={() => setSelected(idx as 0 | 1)}
            className={`flex items-center justify-between px-3 py-2.5 rounded-lg cursor-pointer transition-all border ${
              selected === idx
                ? 'border-teal-500/60 bg-teal-500/10'
                : 'border-slate-700/60 bg-slate-800/40 hover:border-slate-600'
            }`}
          >
            <div className="flex-1 min-w-0">
              <div className={`text-sm font-semibold truncate ${selected === idx ? 'text-teal-300' : 'text-slate-200'}`}>
                {team.name}
              </div>
              <div className="text-xs text-slate-500 mt-0.5">Prob: {team.prob}</div>
            </div>
            <div className="text-right pl-3 flex-shrink-0">
              <div className="text-xs text-slate-400">Price: {team.price}</div>
              <div className="text-xs text-slate-300 font-medium">Payout {team.payout}</div>
              <div className="text-xs text-teal-400 font-semibold">{team.profit}</div>
            </div>
          </div>
        ))}
      </div>

      {/* Add to Slip */}
      <div className="px-3 pb-4 pt-1">
        <button
          onClick={handleAddToSlip}
          className={`w-full flex items-center justify-center gap-2 py-2.5 rounded-lg text-sm font-bold transition-all cursor-pointer whitespace-nowrap border ${
            added
              ? 'bg-teal-500/20 border-teal-500/50 text-teal-300'
              : 'bg-teal-500/10 border-teal-500/30 text-teal-400 hover:bg-teal-500/20 hover:border-teal-500/50'
          }`}
        >
          <i className={`text-sm ${added ? 'ri-check-line' : 'ri-add-circle-line'}`}></i>
          {added ? 'Added!' : 'Add to Slip'}
        </button>
      </div>
    </div>
  );
}

// ─── Nav Config ───────────────────────────────────────────────────────────────

const FILTER_TABS = [
  { key: 'all', label: 'All' },
  { key: 'NFL', label: 'NFL' },
  { key: 'NBA', label: 'NBA' },
  { key: 'NHL', label: 'NHL' },
];

const SUBNAV = [
  { key: 'all', label: 'All', icon: 'ri-apps-2-line', href: '/markets' },
  { key: 'spreads', label: 'Spreads', icon: 'ri-bar-chart-grouped-line', href: '/markets/spreads' },
  { key: 'money-lines', label: 'Money Lines', icon: 'ri-copper-coin-line', href: '/markets/money-lines' },
  { key: 'futures', label: 'Futures', icon: 'ri-calendar-event-line', href: '/markets/futures' },
  { key: 'parlays', label: 'Parlays', icon: 'ri-stack-line', href: '/markets/parlays' },
  { key: 'player-props', label: 'Player Props', icon: 'ri-user-star-line', href: '/markets/player-props' },
];

const marketSubLinks = [
  { href: '/markets/spreads', icon: 'ri-bar-chart-grouped-line', label: 'Spreads' },
  { href: '/markets/money-lines', icon: 'ri-copper-coin-line', label: 'Money Lines' },
  { href: '/markets/futures', icon: 'ri-calendar-event-line', label: 'Futures' },
  { href: '/markets/parlays', icon: 'ri-stack-line', label: 'Parlays' },
  { href: '/markets/player-props', icon: 'ri-user-star-line', label: 'Player Props' },
];

// ─── Page ─────────────────────────────────────────────────────────────────────

export default function SpreadsPage() {
  const navigate = useNavigate();
  const [activeFilter, setActiveFilter] = useState<string>('all');
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [marketsDropdownOpen, setMarketsDropdownOpen] = useState(false);
  const marketsDropdownRef = useRef<HTMLDivElement>(null);
  const { items: slipItems, toggleSlip } = useBetSlip();

  const filtered = activeFilter === 'all'
    ? ALL_CARDS
    : ALL_CARDS.filter(c => c.sport === activeFilter);

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (marketsDropdownRef.current && !marketsDropdownRef.current.contains(e.target as Node)) {
        setMarketsDropdownOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  useEffect(() => {
    const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';
    const schemaId = 'schema-spreads';
    const existing = document.getElementById(schemaId);
    if (existing) existing.remove();
    const script = document.createElement('script');
    script.id = schemaId;
    script.type = 'application/ld+json';
    script.text = JSON.stringify({
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      name: 'Point Spreads — L2L Sports Prediction Market',
      description: 'Trade point spread markets on NFL, NBA, and NHL games. Zero juice, peer-to-peer pricing on all spread bets.',
      url: `${siteUrl}/markets/spreads`,
      breadcrumb: {
        '@type': 'BreadcrumbList',
        itemListElement: [
          { '@type': 'ListItem', position: 1, name: 'Home', item: siteUrl },
          { '@type': 'ListItem', position: 2, name: 'Markets', item: `${siteUrl}/markets` },
          { '@type': 'ListItem', position: 3, name: 'Spreads', item: `${siteUrl}/markets/spreads` },
        ],
      },
    });
    document.head.appendChild(script);
    return () => {
      const el = document.getElementById(schemaId);
      if (el) el.remove();
    };
  }, []);

  return (
    <div className="min-h-screen" style={{ background: '#2b2b2b' }}>
      {/* Demo Banner */}
      <div className="bg-amber-500 text-slate-900 px-4 py-2 relative z-[100] shadow-md">
        <div className="max-w-7xl mx-auto flex items-center justify-center gap-2 text-center">
          <i className="ri-alert-line text-lg"></i>
          <span className="font-bold text-sm md:text-base tracking-wide uppercase">
            Demo Only — Experience the Future of Sports Betting — From Sportsbook to Prediction Market
          </span>
        </div>
      </div>

      {/* Navigation */}
      <nav className="sticky top-0 z-50 backdrop-blur-lg border-b border-slate-700/50 transition-colors duration-300" style={{ background: 'rgba(43,43,43,0.97)' }}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between py-3 gap-4">
            <a className="flex items-center gap-2 group flex-shrink-0" href="/">
              <div className="h-11 w-44 flex items-center justify-center">
                <img
                  src="https://static.readdy.ai/image/bc21bbd943df20a73e2c62e0eb37a79f/356d7ca1b6cdb5f780c70d0d0bd7c02d.png"
                  alt="RTJ Logo"
                  className="h-full w-full object-contain"
                />
              </div>
            </a>
            <div className="hidden lg:flex items-center justify-center gap-1 flex-1">
              <a href="/"><div className="px-4 py-2 rounded-lg text-sm font-medium transition-all cursor-pointer whitespace-nowrap flex items-center gap-2 text-slate-300 hover:bg-slate-800/50 hover:text-white"><i className="ri-home-line w-4 h-4 flex items-center justify-center"></i>Home</div></a>
              <a href="/march-madness"><div className="px-4 py-2 rounded-lg text-sm font-medium transition-all cursor-pointer whitespace-nowrap flex items-center gap-2 text-slate-300 hover:bg-slate-800/50 hover:text-white"><i className="ri-basketball-line w-4 h-4 flex items-center justify-center"></i>March Madness</div></a>
              <a href="/super-bowl-props"><div className="px-4 py-2 rounded-lg text-sm font-medium transition-all cursor-pointer whitespace-nowrap flex items-center gap-2 text-slate-300 hover:bg-slate-800/50 hover:text-white"><i className="ri-football-line w-4 h-4 flex items-center justify-center"></i>Super Bowl</div></a>
              <div className="relative" ref={marketsDropdownRef}>
                <button
                  onClick={() => setMarketsDropdownOpen(o => !o)}
                  className="px-4 py-2 rounded-lg text-sm font-medium transition-all cursor-pointer whitespace-nowrap flex items-center gap-2 bg-teal-500/20 text-teal-400"
                >
                  <i className="ri-bar-chart-2-line w-4 h-4 flex items-center justify-center"></i>
                  Markets
                  <i className={`ri-arrow-down-s-line text-xs transition-transform ${marketsDropdownOpen ? 'rotate-180' : ''}`}></i>
                </button>
                {marketsDropdownOpen && (
                  <div className="absolute top-full left-0 mt-1 w-52 rounded-xl border border-slate-700/80 shadow-2xl overflow-hidden z-50" style={{ background: 'rgba(30,30,30,0.98)' }}>
                    {marketSubLinks.map(link => (
                      <a key={link.href} href={link.href} onClick={() => setMarketsDropdownOpen(false)}>
                        <div className={`flex items-center gap-3 px-4 py-2.5 text-sm transition-colors cursor-pointer ${link.href === '/markets/spreads' ? 'bg-teal-500/10 text-teal-400' : 'text-slate-300 hover:bg-slate-800/60 hover:text-white'}`}>
                          <i className={`${link.icon} w-4 h-4 flex items-center justify-center ${link.href === '/markets/spreads' ? 'text-teal-400' : 'text-slate-500'}`}></i>
                          {link.label}
                        </div>
                      </a>
                    ))}
                    <div className="border-t border-slate-700/50">
                      <a href="/markets" onClick={() => setMarketsDropdownOpen(false)}>
                        <div className="flex items-center gap-3 px-4 py-2.5 text-sm text-slate-400 hover:bg-slate-800/60 hover:text-white transition-colors cursor-pointer">
                          <i className="ri-apps-2-line w-4 h-4 flex items-center justify-center text-slate-500"></i>
                          All Markets
                        </div>
                      </a>
                    </div>
                  </div>
                )}
              </div>
              <a href="/why-rtj">
                <div className="px-4 py-2 rounded-lg text-sm font-medium transition-all cursor-pointer whitespace-nowrap flex items-center gap-2 text-slate-300 hover:bg-slate-800/50 hover:text-white">
                  <i className="ri-question-line w-4 h-4 flex items-center justify-center"></i>
                  Why L2L
                </div>
              </a>
              <a href="/my-account"><div className="px-4 py-2 rounded-lg text-sm font-medium transition-all cursor-pointer whitespace-nowrap flex items-center gap-2 text-slate-300 hover:bg-slate-800/50 hover:text-white"><i className="ri-user-line w-4 h-4 flex items-center justify-center"></i>My Account</div></a>
            </div>
            <div className="flex items-center gap-2 flex-shrink-0">
              <div className="hidden sm:flex items-center gap-2 px-3 py-2 bg-gradient-to-r from-teal-500/20 to-teal-600/10 rounded-lg border border-teal-500/30">
                <i className="ri-wallet-3-line text-teal-400 text-sm"></i>
                <span className="font-semibold text-white text-sm whitespace-nowrap">$10,000</span>
              </div>
              <button onClick={toggleSlip} className="relative p-2 bg-slate-800 hover:bg-slate-700 text-slate-300 rounded-lg border border-slate-700 transition-colors cursor-pointer" title="Bet Slip">
                <i className="ri-file-list-3-line text-teal-500 text-lg w-5 h-5 flex items-center justify-center"></i>
                {slipItems.length > 0 && <span className="absolute -top-1 -right-1 w-4 h-4 bg-teal-500 text-white text-xs rounded-full flex items-center justify-center font-bold">{slipItems.length}</span>}
              </button>
              <a href="/my-account"><div className="p-2 rounded-lg transition-colors cursor-pointer bg-slate-800 hover:bg-slate-700 text-slate-300 border border-slate-700"><i className="ri-user-line text-lg w-5 h-5 flex items-center justify-center"></i></div></a>
              <button onClick={() => setMobileMenuOpen(!mobileMenuOpen)} className="lg:hidden p-2 text-slate-300 hover:text-white hover:bg-slate-800/50 rounded-lg transition-colors cursor-pointer" aria-label="Toggle menu">
                <i className={`text-xl ${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
              </button>
            </div>
          </div>
          {mobileMenuOpen && (
            <div className="lg:hidden border-t border-slate-700/50 py-3 space-y-1">
              {[
                { href: '/', icon: 'ri-home-line', label: 'Home' },
                { href: '/march-madness', icon: 'ri-basketball-line', label: 'March Madness' },
                { href: '/super-bowl-props', icon: 'ri-football-line', label: 'Super Bowl' },
                { href: '/markets', icon: 'ri-bar-chart-2-line', label: 'All Markets' },
                { href: '/markets/spreads', icon: 'ri-bar-chart-grouped-line', label: 'Spreads' },
                { href: '/markets/money-lines', icon: 'ri-copper-coin-line', label: 'Money Lines' },
                { href: '/markets/futures', icon: 'ri-calendar-event-line', label: 'Futures' },
                { href: '/markets/parlays', icon: 'ri-stack-line', label: 'Parlays' },
                { href: '/markets/player-props', icon: 'ri-user-star-line', label: 'Player Props' },
                { href: '/why-rtj', icon: 'ri-question-line', label: 'Why L2L' },
                { href: '/my-account', icon: 'ri-user-line', label: 'My Account' },
              ].map(item => (
                <a key={item.href} href={item.href}>
                  <div className="flex items-center gap-3 px-4 py-2.5 rounded-lg text-slate-300 hover:bg-slate-800/50 hover:text-white transition-colors cursor-pointer">
                    <i className={`${item.icon} text-base`}></i>
                    <span className="text-sm font-medium">{item.label}</span>
                  </div>
                </a>
              ))}
            </div>
          )}
        </div>
      </nav>

      {/* Hero */}
      <PageHero
        title="Point Spreads"
        subtitle="Trade on the margin of victory - All shares $1.00"
        badgeLabel="Live Markets"
        badgeColor="bg-teal-500/20 border-teal-500/40 text-teal-400"
        backgroundImage="https://public.readdy.ai/ai/img_res/0ef1004bb33927a503ce04c44476cd0d.jpg"
      />

      {/* Sub Navigation */}
      <div className="sticky top-[57px] z-40 border-b border-slate-700/50" style={{ background: 'rgba(22,22,22,0.98)' }}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center gap-1 overflow-x-auto scrollbar-none py-2">
            {SUBNAV.map(sub => (
              <a key={sub.key} href={sub.href}>
                <div className={`flex items-center gap-2 px-4 py-1.5 rounded-md text-sm font-medium whitespace-nowrap transition-all cursor-pointer flex-shrink-0 ${
                  sub.key === 'spreads'
                    ? 'bg-slate-700 text-white border border-slate-500/60'
                    : 'text-slate-400 hover:text-slate-200 hover:bg-slate-800/60 border border-transparent'
                }`}>
                  <i className={`${sub.icon} text-sm ${sub.key === 'spreads' ? 'text-teal-400' : 'text-slate-500'}`}></i>
                  {sub.label}
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>

      {/* Filter Tabs */}
      <div className="border-b border-slate-700/50" style={{ background: 'rgba(30,30,30,0.9)' }}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-3">
          <div className="flex items-center gap-2">
            {FILTER_TABS.map(tab => (
              <button
                key={tab.key}
                onClick={() => setActiveFilter(tab.key)}
                className={`px-5 py-1.5 rounded-full text-sm font-bold transition-all cursor-pointer whitespace-nowrap border ${
                  activeFilter === tab.key
                    ? 'bg-teal-500 border-teal-500 text-white shadow-lg shadow-teal-500/20'
                    : 'bg-transparent border-slate-600 text-slate-400 hover:border-slate-400 hover:text-slate-200'
                }`}
              >
                {tab.label}
              </button>
            ))}
          </div>
        </div>
      </div>

      {/* Cards Grid */}
      <section className="py-6 px-4">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
            {filtered.map((card, idx) => (
              <SpreadCardItem key={idx} card={card} />
            ))}
          </div>
          {filtered.length === 0 && (
            <div className="text-center py-20 text-slate-500">
              <i className="ri-bar-chart-grouped-line text-4xl mb-3 block"></i>
              <p>No spread markets available for {activeFilter} at this time.</p>
            </div>
          )}
        </div>
      </section>

      {/* Footer */}
      <footer className="border-t border-slate-700/50 py-8 px-4 mt-8" style={{ background: '#1e1e1e' }}>
        <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="h-10 w-40 flex items-center justify-center">
            <img
              src="https://static.readdy.ai/image/bc21bbd943df20a73e2c62e0eb37a79f/356d7ca1b6cdb5f780c70d0d0bd7c02d.png"
              alt="RTJ Logo"
              className="h-full w-full object-contain"
            />
          </div>
          <p className="text-slate-600 text-xs text-center">Demo only. Not real money. For educational purposes only. Must be 18+ to participate.</p>
          <div className="flex items-center gap-4 text-slate-500 text-xs">
            <a href="/" className="hover:text-slate-300 transition-colors cursor-pointer">Home</a>
            <a href="/super-bowl-props" className="hover:text-slate-300 transition-colors cursor-pointer">Super Bowl</a>
            <a href="/olympics-props" className="hover:text-slate-300 transition-colors cursor-pointer">Olympics</a>
          </div>
        </div>
      </footer>
    </div>
  );
}
